import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequsetForm.XeroContactRequestForm', {
    title: 'CONTACT DETAILS',
    billingAddress: 'Billing Address',
    deliveryAddress: 'Delivery Address',
    sameAsBillingAddress: 'Same as Billing Address',
    salesSettings: 'Sales Settings',
    purchaseSettings: 'Purchase Settings',
    requiredField: 'Field "{field}" is required',
    invalidContactName: 'Contact name cannot contain the following symbols: "<". ">", "&#"',
    invalidSortCode: 'Sort code should be 6 digits',
    invalidBankAccountDetails: 'Bank account number should be 8 digits',
    emailIsEmpty: 'Additional people cannot be added when the primary person has no email address set.',
    saveAndSubmitRequestSuccess: 'The request is submitted for approval.',
    validationError:
        'Some fields are incomplete or contain errors. Please review the highlighted sections and try again.',
});
